import Box from '@mui/system/Box';
import { useSmartTable } from '@qre-mailing/smart-table';
import { FC } from 'react';

import SampleDataTab from '../../components/SampleDataTab/SampleDataTab';
import { usePredefinedFilters } from '../../hooks/usePredefinedFilters';
import { useQueryParams } from '../../hooks/useQueryParams';
import { useSampleNewRowConfig } from '../../hooks/useSampleNewRowConfig';
import { useSamplesTableApi } from '../../hooks/useSamplesTableApi';
import { defineStyles } from '../../theme';

const styles = defineStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    overflowX: 'auto',
    p: 1,
  },
});

export type SampleDataPageProps = {
  qreId: string;
};

const SampleDataPage: FC<SampleDataPageProps> = ({ qreId }) => {
  const queryParams = useQueryParams();
  const { api, deleteConfirmDialog } = useSamplesTableApi(qreId);
  const predefinedFilters = usePredefinedFilters(qreId);
  const { prepareNewRow, newRowFieldOverrides, renderExtraContent } = useSampleNewRowConfig(qreId);

  const sampleDataTable = useSmartTable({
    tableKey: qreId,
    api,
    setQueryParam: queryParams.set,
    getQueryParam: queryParams.get,
    rowsSelectEnabled: true,
    defaultHiddenColumns: [],
    defaultSorting: [{ fieldName: 'ipsosId', direction: 'ASC' }],
    onInvalidate: predefinedFilters.reloadPredefinedFilters,
    prepareNewRow,
    newRowFieldOverrides,
    renderExtraContent,
  });

  return (
    <Box role="tabpanel" sx={styles.root}>
      <SampleDataTab
        qreId={qreId}
        table={sampleDataTable}
        exportSampleApiCall={api.exportSampleApiCall}
        predefinedFilters={predefinedFilters}
      />
      {deleteConfirmDialog}
    </Box>
  );
};

export default SampleDataPage;
